import styled from "@emotion/styled";
import { ToggleButton as ToggleButtonRaw } from "components/ToggleButton/ToggleButton";
import { throttle } from "lodash-es";
import { GlobalStore } from "store/global/GlobalStore";

export const DebugPanelTokenListToggle = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const customTokenListUrl = GlobalStore.useState(s => s.customTokenListUrl);
  const isCustomTokenList = GlobalStore.useState(s => s.isCustomTokenList);
  const forceSolver = GlobalStore.useState(s => s.forceSolver);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignContent: "center",
          font: theme.Desktop.Paragraph.Medium,
          marginBottom: 6,
        }}
      >
        <span>Custom loken list</span>
        <ToggleButton
          toggleButtonText=""
          checked={isCustomTokenList}
          handleOnToggle={() => {
            GlobalStore.update(s => {
              s.isCustomTokenList = !isCustomTokenList;
            });
          }}
        />
      </div>
      {isCustomTokenList && (
        <textarea
          style={{ font: theme.Desktop.Paragraph.Medium, width: "100%" }}
          value={customTokenListUrl}
          onClick={e => {
            e.stopPropagation();
          }}
          onChange={throttle<(e: React.ChangeEvent<HTMLTextAreaElement>) => void>(e => {
            GlobalStore.update(s => {
              s.customTokenListUrl = e.target.value;
            });
          }, 500)}
        />
      )}
      <div
        style={{
          display: "flex",
          alignContent: "center",
          font: theme.Desktop.Paragraph.Medium,
          marginBottom: 6,
        }}
      >
        <span>Solver</span>
        <input
          style={{ font: theme.Desktop.Paragraph.Medium, width: "100%" }}
          value={forceSolver}
          onClick={e => {
            e.stopPropagation();
          }}
          onChange={throttle<(e: React.ChangeEvent<HTMLInputElement>) => void>(e => {
            GlobalStore.update(s => {
              s.forceSolver = e.target.value;
            });
          }, 500)}
        />
      </div>
    </div>
  );
};

// Sub-components

const ToggleButton = styled(ToggleButtonRaw)(() => {
  return { color: "white!important" };
});
